module.exports = __webpack_public_path__ + "static/media/ic-filter-outline.4ee3b8ee.svg";